import { ENV } from '../config';
export const HandlePublishDate = (data: any): any => {
    if (Array.isArray(data)) {
      return data.filter(item => {
        const processedItem = HandlePublishDate(item);
        return processedItem !== null; // 过滤掉返回 null 的元素
      });
    } else if (typeof data === 'object' && data !== null) {
      const newData = { ...data };
      if (newData.attributes && (ENV === 'preproduction' ? newData.attributes.createdAt : newData.attributes.publishedAt) === null) {
        return null; // 返回 null 表示移除该对象
      } else if (newData.attributes) {
        newData.attributes = HandlePublishDate(newData.attributes);
        if (newData.attributes === null) return null; // 如果 attributes 处理后为 null，则移除该对象
      }
      for (const key in newData) {
        if (newData.hasOwnProperty(key) && typeof newData[key] === 'object' && newData[key] !== null) {
          newData[key] = HandlePublishDate(newData[key]);
          if (newData[key] === null) delete newData[key]; // 如果子对象处理后为 null，则移除该属性
        }
      }
      return newData;
    } else {
      return data;
    }
  };